<template>
  <div class="content-container">
    <a-form-model class="search-form" layout="inline" :model="searchParam">
      <a-form-model-item layout="vertical">
        <a-button
          type="primary"
          :style="{ margin: '0px 15px' }"
          @click="addCate(0)"
          >{{$t('actionTitles.add')}}</a-button
        >
      </a-form-model-item>
    </a-form-model>

    <div class="table-wrapper">
      <a-table
        :data-source="data"
        :loading="loading"
        rowKey="id"
        :indentSize="30"
      >
        <a-table-column key="id" :title="$t('table.cate.thead.id')" data-index="id" align="center">
          <template slot-scope="text, record">
            <span>{{ record.id }}</span>
          </template>
        </a-table-column>

        <a-table-column
          key="name"
          :title="$t('table.cate.thead.name')"
          data-index="name"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.name }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="sort_order"
          :title="$t('table.common.thead.sort')"
          data-index="sort_order"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.sort_order }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a @click.stop="editCate(record)">{{$t('actionTitles.edit')}}</a>
              <a-divider type="vertical" />
              <template v-if="record.pid === 0">
                <a @click.stop="addCate(record.id)">{{$t('actionTitles.addChildCate')}}</a>
                <a-divider type="vertical" />
              </template>
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => delCate(record.id)"
              >
                <a href="javascript:;" style="color: red">{{
                  $t(`actionTitles.delete`)
                }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      :title="modelTitle"
      :visible="isShowModel"
      @ok="saveCate"
      @cancel="cancelSave"
      keyboard
    >
      <a-form-model
        ref="cateForm"
        :model="cateForm"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 14 }"
        :okText="$t('actionTitles.ascertain')"
        :cancelText="$t('actionTitles.cancel')"
      >
        <a-form-model-item ref="name" :label="$t('form.cate.field.labelParent')" prop="pid">
          <a-tree-select
            v-model="cateForm.pid"
            :replaceFields="{
              children: 'children',
              title: 'name',
              key: 'id',
              value: 'id',
            }"
            :tree-data="treeSelectData"
            tree-default-expand-all
          ></a-tree-select>
        </a-form-model-item>
        <a-form-model-item ref="name" :label="$t('form.cate.field.label')" prop="name">
          <a-input
            v-model="cateForm.name"
            :placeholder="$t('form.cate.field.placeholder')"
            @blur="
              () => {
                $refs.name.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('table.common.thead.sort')">
           <a-input-number  v-model="cateForm.sort_order" :min="0"   :placeholder="$t('message.sortTip')"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import { getTree, save, del, detail } from "@/api/articleCate";

const defaultCateForm = {
  id: null,
  pid: 0,
  name: "",
  sort_order: 99,
};
export default {
  data() {
    return {
      searchParam: {
        current_page: 1,
        per_page: 10,
        name: "",
        order: {},
      },
      data: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      isShowModel: false,
      modelTitle: "",
      cateForm: {
        id: null,
        pid: 0,
        name: "",
        sort_order: 99,
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t('form.cate.field.placeholder'),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    treeSelectData() {
      let children = [];
      this.data.forEach((item) => {
        if (item.hasOwnProperty("children")) {
          item = { ...item };
          item.children = null;
        }
        children.push(item);
      });
      return [{ id: 0, name: this.$t('form.article.type.defaultName'), children }];
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      getTree()
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.data = res.data;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleReset() {
      this.searchParam = { status: [] };
      this.loadData();
    },
    resetForm() {
      this.$refs.cateForm.resetFields();
      this.cateForm = defaultCateForm;
    },
    handleChangeSelect(value) {
      this.cateForm.type = value;
    },
    cancelSave() {
      this.isShowModel = false;
      this.$refs.cateForm.resetFields();
    },
    addCate(pid) {
      this.modelTitle = this.$t('form.cate.add.title');
      this.isShowModel = true;
      this.$nextTick(() => {
        this.resetForm();
        this.cateForm.pid = pid;
      });
    },
    saveCate() {
      this.$refs.cateForm.validate((valid) => {
        if (valid) {
          save(this.cateForm)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success(this.$t("message.saveSuccess"), 2, () => {
                  this.isShowModel = false;
                  this.loadData();
                });
              }
            })
            .catch((err) => {});
        }
      });
    },
    editCate(item) {
      this.modelTitle = this.$t('form.cate.modify.title');
      detail({ id: item.id }).then((res) => {
        this.isShowModel = true;
        this.$nextTick(() => {
          this.resetForm();
          this.cateForm = res.data;
        });
      });
    },
    delCate(id) {
      del({ id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.loadData();
            });
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="less" scoped>
.ant-input-number{
  width: 100%;
}
</style>
